import React, { useEffect, useState } from "react";
import { FiDatabase } from "react-icons/fi";
import { RiAddLargeFill, RiDeleteBin6Line } from "react-icons/ri";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FaArrowRightLong, FaArrowDownLong } from "react-icons/fa6";
import { useNavigate, useSearchParams } from "react-router-dom";
import TablesModal from "./TablesModal";
import ChangeBaseTableModal from "./ChangeBaseTableModal";
import TableRelationModal from "./TableRelationModal";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import {
  usePreviewTableMutation,
  useJoinMutation,
  useGetRelationsMutation,
  useDeleteRelationMutation,
  useEditRelationMutation,
  useResetTempDataSourceMutation,
  useCommitDataSourceMutation,
} from "./JoinTableApiSlice";
import { LuEraser } from "react-icons/lu";
import { AiOutlineSave } from "react-icons/ai";
import { Dropdown, DropdownItem } from "flowbite-react";

export default function JoinTable() {
  const [searchParams] = useSearchParams();
  const baseDatabaseName = searchParams.get("database");
  // // console.log(baseDatabaseName);
  const databaseId = searchParams.get("id");
  // // console.log(databaseId);
  const baseTable = searchParams.get("table");
  // // console.log(baseTable);
  const [droppedItems, setDroppedItems] = useState([]);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  // // console.log(droppedItems);
  const [modal, setModal] = useState(null);
  const [isRelationshipModal, setIsRelationshipModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [joinObject, setJoinObject] = useState({
    baseTableName: baseTable,
    baseColumnName: null,
    newTableName: null,
    newColumnName: null,
    originalDataSourceId: databaseId,
    newTableDatabase: baseDatabaseName,
    joinType: null,
    customSQL: null,
  });
  const [baseTableModal, setBaseTableModal] = useState(false);
  // // console.log(joinObject);
  const [requiredTable, setRequiredTable] = useState([]);
  // preview the table
  const [
    previewTable,
    {
      data: previewTableData,
      isLoading: isPreviewTableLoading,
      isError: isPreviewTableError,
      isSuccess: isPreviewTableSuccess,
      error: previewTableError,
    },
  ] = usePreviewTableMutation();
  // join
  const [
    join,
    {
      data: joinData,
      isLoading: isJoinLoading,
      isError: isJoinError,
      isSuccess: isJoinSuccess,
      error: joinError,
    },
  ] = useJoinMutation();
  //  relations
  const [
    getRelations,
    {
      data: relationshipStringData,
      isLoading: isRelationshipStringLoading,
      isError: isRelationshipStringError,
      isSuccess: isRelationshipStringSuccess,
      error: relationshipStringError,
    },
  ] = useGetRelationsMutation();
  // delete relation
  const [
    deleteRelation,
    {
      data: deleteRelationData,
      isLoading: isDeleteRelationLoading,
      isError: isDeleteRelationError,
      isSuccess: isDeleteRelationSuccess,
      error: deleteRelationError,
    },
  ] = useDeleteRelationMutation();
  // Edit Relation
  const [
    editRelation,
    {
      data: editRelationData,
      isError: isEditRelationError,
      isLoading: isEditRelationLoading,
      isSuccess: isEditRelationSuccess,
      error: editRelationError,
    },
  ] = useEditRelationMutation();
  // resetTempDataSource
  const [
    resetTempDataSource,
    {
      data: resetTempDSData,
      isError: isResetTempDSError,
      isLoading: isResetTempDSLoading,
      isSuccess: isResetTempDSSuccess,
      error: resetTempDSError,
    },
  ] = useResetTempDataSourceMutation();
  // commitDataSource
  const [
    commitDataSource,
    {
      data: commitDSData,
      isError: isCommitDSError,
      isLoading: isCommitDSLoading,
      isSuccess: isCommitDSSuccess,
      error: commitDSError,
    },
  ] = useCommitDataSourceMutation();

  const handleTableSelection = ({ table, addType, sourceId, relationId }) => {
    const localItems = [...droppedItems];
    const sourceItem = localItems.find((i) => i.id === sourceId);

    if (!sourceItem) {
      console.error("Source item not found for:", sourceId);
      return;
    }

    // Determine position based on addType
    let gridRowStart = sourceItem.gridRowStart || 1;
    let gridColumnStart = sourceItem.gridColumnStart || 1;

    if (addType === "rows") {
      gridRowStart += 1;
    } else if (addType === "columns") {
      gridColumnStart += 1;
    }

    const newItemObject = {
      id: table,
      tableName: table,
      columns: [],
      isCollapsed: false,
      addType,
      sourceId,
      gridRowStart,
      gridColumnStart,
      relationId,
    };

    // Add the new item since we've confirmed it's not a duplicate
    setDroppedItems((prev) => {
      // Check for duplicate before proceeding
      if (prev.some((d) => d.id === table)) {
        return prev; // Return previous state instead of undefined
      }
      return [...prev, newItemObject];
    });
  };

  useEffect(() => {
    if (isRelationshipStringSuccess && relationshipStringData) {
      const relationshipArray = relationshipStringData["relationArray"];
      const requiredRelationShipArray = relationshipArray.map((item) => {
        return {
          table: item["newTableName"],
          addType: "columns",
          sourceId: item["baseTableName"],
          relationId: item["_id"],
        };
      });
      // console.log(requiredRelationShipArray);

      requiredRelationShipArray.forEach(
        ({ table, addType, sourceId, relationId }) => {
          handleTableSelection({ table, addType, sourceId, relationId });
        }
      );
    }
  }, [isRelationshipStringSuccess]);

  useEffect(() => {
    const firstItemObject = {
      id: baseTable,
      tableName: baseTable,
      columns: [],
      isCollapsed: false,
      gridRowStart: 1,
      gridColumnStart: 1,
    };
    setDroppedItems([firstItemObject]);
  }, [baseTable]);

  useEffect(() => {
    if (databaseId) {
      const object = {
        dataSourceID: databaseId,
      };
      previewTable(object);
    }
  }, []);

  useEffect(() => {
    if (databaseId) {
      const object = {
        originalDataSourceId: databaseId,
      };
      getRelations(object);
    }
  }, []);

  const joinFunction = async (joinObject) => {
    function hasNullOrUndefinedValue(obj) {
      return Object.entries(obj).some(
        ([key, value]) =>
          key !== "customSQL" && (value === null || value === undefined)
      );
    }

    if (!hasNullOrUndefinedValue(joinObject)) {
      // console.log("call the join");

      try {
        const joinResponse = await join(joinObject);
        // console.log(joinResponse?.data?.message);

        // refetch the previewTableData
        if (joinResponse?.data?.message && databaseId) {
          const previewObject = { dataSourceID: databaseId };
          previewTable(previewObject);

          // Get relations
          const relationObject = { originalDataSourceId: databaseId };
          const relationResponse = await getRelations(relationObject); // Make sure getRelations returns a promise
          // console.log(relationResponse["data"]["relationArray"]);

          // process the response here
          const relationshipArray =
            relationResponse["data"]["relationArray"] ?? [];
          const requiredRelationShipArray = relationshipArray.map((item) => ({
            table: item.newTableName,
            addType: "columns",
            sourceId: item.baseTableName,
            relationId: item._id,
          }));
          requiredRelationShipArray.forEach(
            ({ table, addType, sourceId, relationId }) => {
              handleTableSelection({ table, addType, sourceId, relationId });
            }
          );
        }
      } catch (error) {
        console.error("Error during join or fetching relations:", error);
      }
    } else {
      console.error(
        "Join object has null or undefined values (excluding customSQL)."
      );
    }
  };
  const editJoinFunction = (joinObject) => {
    const object = {
      originalDataSourceId: joinObject?.originalDataSourceId,
      newRelation: {
        baseTableName: joinObject?.baseTableName,
        baseColumnName: joinObject?.baseColumnName,
        newTableName: joinObject?.newTableName,
        newColumnName: joinObject?.newColumnName,
        joinType: joinObject?.joinType,
        customSQL: joinObject?.customSQL,
        _id: joinObject?._id,
      },
      relationId: joinObject?._id,
    };
    // console.log(object);
    editRelation(object);
  };

  useEffect(() => {
    if (isPreviewTableSuccess && previewTableData) {
      setRequiredTable(previewTableData?.["response"]?.["result"]?.["data"]);
    }
  }, [isPreviewTableSuccess]);

  const handleRemoveItem = async (droppedItem) => {
    // console.log(droppedItem);

    if (databaseId && droppedItem["relationId"]) {
      try {
        const deleteObject = {
          originalDataSourceId: databaseId,
          relationId: droppedItem["relationId"],
        };
        await deleteRelation(deleteObject); // Await the deletion

        // Get updated relations
        const relationObject = { originalDataSourceId: databaseId };
        const relationResponse = await getRelations(relationObject); // Await the relation fetch

        const relationshipArray = relationResponse?.data?.relationArray ?? [];
        // console.log(relationshipArray);

        const requiredRelationShipArray = relationshipArray.map((item) => ({
          table: item.newTableName,
          addType: "columns",
          sourceId: item.baseTableName,
          relationId: item._id,
        }));

        requiredRelationShipArray.forEach(
          ({ table, addType, sourceId, relationId }) => {
            handleTableSelection({ table, addType, sourceId, relationId });
          }
        );

        // Refresh preview table
        const previewObject = { dataSourceID: databaseId };
        previewTable(previewObject);
      } catch (error) {
        console.error(
          "Error removing item or fetching updated relations:",
          error
        );
      }
    } else {
      console.warn("Missing databaseId or relationId.");
    }

    // Optionally update local state here if needed
    let localItems = droppedItems.filter(
      (lItem) => lItem.id !== droppedItem.id
    );
    setDroppedItems(localItems);
  };

  const handleCollapsed = (id) => {
    setDroppedItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, isCollapsed: !item.isCollapsed } : item
      )
    );
  };

  const handleRowAndColumns = (addType, sourceId) => {
    // console.log(addType);
    setModal({ addType, sourceId });
  };

  // Get unique columns from the first non-empty object
  const columns = Object.keys(
    requiredTable.find((item) => Object.keys(item).length) || {}
  );
  const handleEdit = (item) => {
    if (
      relationshipStringData &&
      relationshipStringData["relationArray"].length &&
      item?.relationId
    ) {
      let requiredRelation = relationshipStringData["relationArray"].find(
        (r) => r._id === item.relationId
      );
      // console.log(requiredRelation);
      requiredRelation = {
        ...requiredRelation,
        newTableDatabase: baseDatabaseName,
        originalDataSourceId: databaseId,
      };
      if (requiredRelation) {
        setJoinObject(requiredRelation);
        setModal({
          addType: "columns",
          sourceId: requiredRelation["baseTableName"],
        });
        setIsEdit(true);
      } else {
        console.error(
          ` requiredRelation is null or undefined ${requiredRelation}`
        );
      }
    }
  };

  const handleResetTempDataSource = () => {
    const resetObject = {
      originalDataSourceId: databaseId,
    };
    resetTempDataSource(resetObject);
    const previewObject = {
      dataSourceID: databaseId,
    };
    previewTable(previewObject);
    const relationObject = {
      originalDataSourceId: databaseId,
    };
    getRelations(relationObject);
    const firstItemObject = {
      id: baseTable,
      tableName: baseTable,
      columns: [],
      isCollapsed: false,
      gridRowStart: 1,
      gridColumnStart: 1,
    };
    setDroppedItems([firstItemObject]);
  };
  const handleCommitDataSource = async () => {
    const object = {
      originalDataSourceId: databaseId,
    };
    try {
      const response = await commitDataSource(object).unwrap();
      setMessage(response.message || "Saved successful.");
      if (response.message) {
        const timer = setTimeout(() => {
          setMessage("");
          navigate("/datasource");
        }, 1500);
        return () => clearTimeout(timer);
      }
    } catch (error) {
      setMessage(error?.data?.error || "Something went wrong during saving.");
    }
  };

  return (
    <>
      <main className="flex flex-col items-center justify-start w-screen h-screen overflow-hidden">
        <header className="flex items-center justify-between border w-full h-[5%] rounded p-1">
          <div className="flex w-auto items-center justify-start gap-x-2 font-medium">
            <FiDatabase className="text-blue-950 text-md" />
            {baseTable}
            <RiAddLargeFill className="text-sm" /> Multiple Connections
          </div>
          <div className="flex w-auto items-center justify-end gap-x-2 font-light">
            {isResetTempDSLoading ? (
              <p className="font-medium">reseting... the data source </p>
            ) : null}
            {isResetTempDSError ? (
              <p className="font-medium text-red-500">
                An error occurred while reset the data source.
              </p>
            ) : null}
            {message && (
              <p
                className={`font-medium ${
                  isCommitDSSuccess ? "text-green-500" : "text-red-500"
                }`}
              >
                {message}
              </p>
            )}
            <button
              className="border border-blue-950 flex items-center px-2 gap-2"
              onClick={handleResetTempDataSource}
            >
              <LuEraser className="text-blue-950" />
              Reset
            </button>
            <button
              className="border bg-blue-950 text-white px-2 gap-2 flex items-center"
              onClick={handleCommitDataSource}
            >
              <AiOutlineSave />
              {isCommitDSLoading ? "Saving..." : " Save"}
            </button>
          </div>
        </header>
        <section
          id="section1"
          className="w-full h-[30%] items-start justify-start border p-2 grid grid-cols-5 grid-rows-2 gap-4 border-t-0"
        >
          {droppedItems.map((item, index) => {
            // console.log(item);

            return (
              <section
                className="flex flex-col items-start justify-start border w-[13rem] relative"
                key={item.id}
                style={{
                  gridColumnStart: item.gridColumnStart,
                  gridRowStart: item.gridRowStart,
                }}
              >
                {/* ↓ Down Arrow for columns above the box */}
                {item.addType === "rows" && (
                  <buttton
                    className="absolute -top-[4rem] left-1/2 transform -translate-x-1/2 text-[3rem] text-gray-400"
                    // onClick={() => handleEdit(item)}
                  >
                    <FaArrowDownLong className="cursor-pointer" />
                  </buttton>
                )}
                {/* → Right Arrow for rows on the left side */}
                {item.addType === "columns" && (
                  <buttton
                    className="absolute -left-[6rem] top-1/2 transform -translate-y-1/2 text-[3rem] text-gray-400"
                    onClick={() => handleEdit(item)}
                  >
                    <FaArrowRightLong className="cursor-pointer" />
                  </buttton>
                )}

                {/* Existing item rendering */}
                <div className="w-full flex items-center justify-start gap-x-2 h-20">
                  <Dropdown
                    arrowIcon={false}
                    inline
                    className="rounded shadow-lg h-auto z-30"
                    label={
                      <PiDotsThreeOutlineVerticalFill className="text-sm" />
                    }
                  >
                    {index > 0 ? (
                      <DropdownItem
                        className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                        onClick={() => handleRemoveItem(item)}
                      >
                        <RiDeleteBin6Line />
                        Delete
                      </DropdownItem>
                    ) : null}
                    {index === 0 ? (
                      <DropdownItem
                        className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                        onClick={() => setBaseTableModal(true)}
                      >
                        <MdOutlinePublishedWithChanges />
                        Change base table
                      </DropdownItem>
                    ) : null}
                  </Dropdown>
                  <button className="flex flex-col justify-center items-start px-2 truncate w-[60%] border-l h-full">
                    <span className="font-medium text-sm">
                      {item.tableName}
                    </span>
                    <span className="text-xs text-gray-600">mysql</span>
                  </button>
                  {!droppedItems.some(
                    (otherItem) =>
                      otherItem.gridColumnStart === item.gridColumnStart + 1 &&
                      otherItem.gridRowStart === item.gridRowStart
                  ) && (
                    <button
                      className="flex flex-col justify-center items-center border-l h-full text-xs px-2 pt-1 gap-2 font-medium"
                      onClick={() => handleRowAndColumns("columns", item.id)}
                    >
                      Columns <RiAddLargeFill />
                    </button>
                  )}
                </div>
                {/* {!droppedItems.some(
                  (otherItem) =>
                    otherItem.gridRowStart === item.gridRowStart + 1 &&
                    otherItem.gridColumnStart === item.gridColumnStart
                ) && (
                  <button
                    className="w-full flex items-center justify-center text-xs gap-2 border-t font-medium p-1"
                    onClick={() => handleRowAndColumns("rows", item.id)}
                  >
                    Rows <RiAddLargeFill />
                  </button>
                )} */}
              </section>
            );
          })}
        </section>
        <section className="w-full h-[70%] flex flex-col items-start justify-start overflow-hidden">
          {isPreviewTableLoading ? (
            <p className="text-start p-1 font-medium">Table is loading...</p>
          ) : isPreviewTableError ? (
            <p className="text-start p-1 font-medium text-red-500">
              <span className="font-medium">
                {previewTableError?.data?.message} :
              </span>
              <br />
              {`error : ${previewTableError?.data?.error}`}
            </p>
          ) : (
            <p className="text-start p-1 font-medium">Table</p>
          )}

          {isPreviewTableSuccess ? (
            <div className="w-full h-[95%] overflow-y-auto">
              <table className="min-w-full text-sm text-left table-auto">
                <thead className="bg-gray-100 sticky top-0 z-10">
                  <tr>
                    {columns.map((col) => (
                      <th
                        key={col}
                        className="px-4 py-2 border-b font-semibold text-gray-700 whitespace-nowrap"
                      >
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {requiredTable.map((row, idx) => (
                    <tr key={idx} className="odd:bg-white even:bg-gray-50">
                      {columns.map((col) => (
                        <td
                          key={col}
                          className="px-4 py-2 border-b whitespace-nowrap"
                        >
                          {String(row[col] ?? "")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </section>
      </main>
      {modal ? (
        <TablesModal
          closeModal={() => setModal(null)}
          addType={modal.addType}
          sourceId={modal.sourceId}
          baseDatabaseName={baseDatabaseName}
          joinObject={joinObject}
          setJoinObject={setJoinObject}
          openRelationshipModal={() => setIsRelationshipModal(true)}
          databaseId={databaseId}
        />
      ) : null}
      {baseTableModal ? (
        <ChangeBaseTableModal
          closeModal={() => setBaseTableModal(false)}
          baseDatabaseName={baseDatabaseName}
          databaseId={databaseId}
        />
      ) : null}
      {isRelationshipModal ? (
        <TableRelationModal
          closeModal={() => setIsRelationshipModal(null)}
          joinObject={joinObject}
          setJoinObject={setJoinObject}
          handleTableSelection={handleTableSelection}
          joinFunction={joinFunction}
          joinData={joinData}
          isJoinLoading={isJoinLoading}
          isJoinError={isJoinError}
          isJoinSuccess={isJoinSuccess}
          joinError={joinError}
          isEdit={isEdit}
          editJoinFunction={editJoinFunction}
          editRelationData={editRelationData}
          isEditRelationError={isEditRelationError}
          isEditRelationLoading={isEditRelationLoading}
          isEditRelationSuccess={isEditRelationSuccess}
          editRelationError={editRelationError}
        />
      ) : null}
    </>
  );
}
